{
  "roles": {
    "owner": "Owner",
    "admin": "Admin",
    "member": "Member",
    "guest": "Guest"
  },
  "role_desc": {
    "admin": "Manages members, projects, and billing.",
    "member": "Creates and edits team projects and tasks.",
    "guest": "Only sees what is explicitly shared with them."
  },
  "priority": {
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "urgent": "Urgent"
  },
  "members": {
    "title": "Team members",
    "subtitle": "Manage who has access to {team} and what they can do.",
    "invite_person": "Invite person",
    "stat_members": "Members",
    "stat_plan": "Current plan",
    "stat_attention": "Heads up",
    "stat_available": "Available space",
    "unlimited_plan": "No limit on this plan.",
    "near_limit": "You're close to the limit. Consider upgrading to a higher plan.",
    "can_add_more": "You can add {n} more.",
    "search_placeholder": "Search by name or email…",
    "loading": "Loading members…",
    "no_match": "No one matches \"{q}\".",
    "no_members": "No members yet.",
    "you": "You",
    "joined_on": "Joined on {date}",
    "action_on": "Actions for {name}",
    "remove_from_team": "Remove from team",
    "owner_only_note": "Only the team owner can change roles or remove members.",
    "confirm_remove_title": "Remove {name} from the team?",
    "confirm_remove_message": "They will immediately lose access to all projects and tasks in this team.",
    "error_change_role": "Couldn't change the role.",
    "error_remove_member": "Couldn't remove the member."
  },
  "profile": {
    "back_to_members": "Back to members",
    "loading": "Loading profile…",
    "error_load": "Couldn't load the profile.",
    "member_since": "Member since {date}",
    "no_team": "No team",
    "create_new_team": "Create new team",
    "team_name_placeholder": "Team name",
    "create_and_assign": "Create and assign",
    "delete_team_title": "Delete the team \"{name}\"?",
    "delete_team_message": "Assigned members will be left without a team.",
    "delete_team_action": "Delete {name}",
    "error_assign_team": "Couldn't assign the team.",
    "error_create_team": "Couldn't create the team.",
    "error_delete_team": "Couldn't delete.",
    "stats": {
      "open": "Open",
      "completed": "Completed",
      "completed_period": "Last 30 days",
      "overdue": "Overdue",
      "projects": "Projects"
    },
    "tasks_title": "Assigned tasks",
    "open_count": "Open ({n})",
    "completed_recent": "Recently completed ({n})",
    "no_tasks": "No tasks assigned in this team.",
    "projects_title": "Projects ({n})",
    "no_projects": "Not in any project.",
    "task_count_one": "{n} task",
    "task_count_other": "{n} tasks",
    "view_all_tasks": "View all",
    "tasks_of": "{name}'s tasks",
    "all_tasks_subtitle": "All tasks assigned in this workspace",
    "back_to_profile": "Back to profile"
  },
  "department": {
    "loading": "Loading team…",
    "error_load": "Couldn't load the team.",
    "back_to_teams": "All teams",
    "members_one": "{n} member",
    "members_other": "{n} members",
    "projects_one": "{n} project",
    "projects_other": "{n} projects",
    "projects_section": "Projects",
    "new_project": "New project",
    "no_projects": "This team has no projects yet.",
    "create_first": "Create the first one",
    "private_label": "Private",
    "no_description": "No description.",
    "tasks_one": "{n} task",
    "tasks_other": "{n} tasks",
    "members_section": "Members",
    "add_member": "Add member",
    "no_members": "No members in this team yet.",
    "add_first": "Add the first one",
    "remove_from_dept": "Remove from team",
    "confirm_remove_member": "Remove {name} from team {dept}?",
    "error_load_members": "Error loading members.",
    "error_add_member": "Error adding member.",
    "error_remove_member": "Error removing member.",
    "error_create_project": "Error creating the project.",
    "modal_new_project_title": "New project",
    "modal_team_label": "Team:",
    "field_name": "Name",
    "field_description": "Description",
    "field_color": "Color",
    "private_project": "Private project",
    "private_project_help": "Only explicit members can see it, ignoring the team.",
    "cancel": "Cancel",
    "creating": "Creating…",
    "create_project": "Create project",
    "modal_add_members_title": "Add members",
    "modal_add_members_subtitle": "Assign workspace members to the {dept} team.",
    "modal_search_placeholder": "Search by name or email…",
    "no_results": "No results.",
    "all_in_team": "All workspace members are already in this team.",
    "add": "Add",
    "add_existing_project": "Add existing",
    "remove_project_from_dept": "Remove from team",
    "confirm_remove_project": "Remove project {name} from team {dept}?",
    "error_load_projects": "Error loading projects.",
    "error_add_project": "Error adding the project.",
    "error_remove_project": "Error removing the project.",
    "modal_add_projects_title": "Add projects",
    "modal_add_projects_subtitle": "Link workspace projects to the {dept} team.",
    "modal_search_project_placeholder": "Search project by name…",
    "no_projects_to_add": "No other projects to add.",
    "currently_in": "Currently in {dept}",
    "tab_boards": "Boards",
    "tab_tasks": "Tasks"
  },
  "tasks": {
    "loading": "Loading tasks…",
    "error_load": "Could not load the team's tasks.",
    "empty": "No tasks match these filters.",
    "status_all": "All",
    "status_pending": "Pending",
    "status_open": "Open",
    "status_in_progress": "In progress",
    "status_done": "Completed",
    "status_cancelled": "Cancelled",
    "overdue_n": "{n} overdue",
    "search_placeholder": "Search task…",
    "filter_all_members": "All members",
    "filter_unassigned": "Unassigned",
    "filter_all_priorities": "Any priority",
    "filter_all_boards": "All boards",
    "clear_filters": "Clear filters",
    "page_of": "Page {current} of {total}",
    "prev": "Previous",
    "next": "Next"
  }
}
